import _ from 'lodash'
import type { ObsoleteBehaviorsList as ObsoleteBehaviorsListType, ActionBehavior } from '@wix/thunderbolt-becky-types'
import { createConsumptionDataNode } from './utils/dataNodeUtils'
import type { DataItemWithOverridesRefs } from '../../types'
import { resolveOverrideItem } from '../../dataConsumption'

const getItemsList = (itemsString: string): Array<ActionBehavior> | null => {
	try {
		const itemsList = JSON.parse(itemsString) as Array<ActionBehavior>
		return itemsList
	} catch (e) {
		console.error('Error parsing ObsoleteBehaviorsList', e)
	}

	return null
}

export const Behaviors = createConsumptionDataNode<ObsoleteBehaviorsListType, null, DataItemWithOverridesRefs>({
	toViewItem: ({ id, value: { dataItemWithOverrides } }) => {
		const { dependencies, ...actionBehaviorDataItem } = resolveOverrideItem(dataItemWithOverrides, id)

		const { items: itemsString } = actionBehaviorDataItem as ObsoleteBehaviorsListType
		const itemsList = getItemsList(itemsString)

		if (!itemsList) {
			return actionBehaviorDataItem
		}

		const fixedItems = _.map(itemsList, (actionBehaviorItem) => {
			const actionSourceId = _.get(actionBehaviorItem, ['action', 'sourceId'])
			const behaviorTargetId = _.get(actionBehaviorItem, ['behavior', 'targetId'])

			if (actionSourceId) {
				actionBehaviorItem.action.sourceId = dependencies[actionSourceId] || actionSourceId
			}

			if (behaviorTargetId) {
				actionBehaviorItem.behavior.targetId = dependencies[behaviorTargetId] || behaviorTargetId
			}

			return actionBehaviorItem
		})

		return {
			...actionBehaviorDataItem,
			id,
			items: JSON.stringify(fixedItems),
		}
	},
})
